const Typography = {
  defaultProps: {
    variantMapping: {
      subtitle2: 'p',
    },
  },
};

export default Typography;
